import { render, staticRenderFns } from "./ScreenObstetricaPerfilCervical.vue?vue&type=template&id=b26358b6&scoped=true&"
import script from "./ScreenObstetricaPerfilCervical.vue?vue&type=script&lang=js&"
export * from "./ScreenObstetricaPerfilCervical.vue?vue&type=script&lang=js&"
import style0 from "./ScreenObstetricaPerfilCervical.vue?vue&type=style&index=0&id=b26358b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b26358b6",
  null
  
)

export default component.exports